/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
// import { getStudentsRequest } from 'src/services/api.service';
import { useNotification } from 'src/contexts/notification.context'
// import { GradeSelect, SubjectSelect } from 'src/components/common'
import { Select } from 'src/components/select'
// import Table from 'src/components/table/table'
// import ClassroomRow from './components/student-row';
// import InviteModal from './modals/invite'
// import { isClass } from 'src/tools'
import {
  getStudentDetailsRequest,
  getChildDetailsRequest,
} from 'src/services/api.service'
import { useAuth } from 'src/contexts/auth.context'
import { routes } from 'src/navigation/routes'

export const TeacherStudentsDetails = () => {
  // const history = useHistory()
  const { user } = useAuth()
  const { id } = useParams()
  const { wrapCallback } = useNotification()
  const [data, setData] = useState({})

  const [filter, setFilter] = useState({
    subject_id: null,
    grade_id: null,
    period: 'month',
  })

  useEffect(() => {
    wrapCallback(async () => {
      console.log(user.role_id)
      const getDetails =
        user.role_id === 1 ? getStudentDetailsRequest : getChildDetailsRequest
      const response = await getDetails(id, filter)
      setData(response.data?.item)
    })
  }, [id, filter])

  return (
    <>
      <div className="cabinet__pannel">
        <div className="cabinet__title__wrapper">
          <Link to={routes.students.index} className="back">
            <img
              src="/account/images/dest/icons/back.svg"
              alt="Back"
              className="back__img"
            />
            Back to all students
          </Link>
          <h1 className="cabinet__title">Student profile</h1>
        </div>
      </div>

      <div className="student__profile">
        <div className="student__profile__inner">
          <div className="student__profile__user">
            <img
              src={
                data.avatar
                  ? data.avatar
                  : '/account/images/dest/student__profile/avatar.svg'
              }
              width="76"
              alt="avatar"
              className="student__profile__img"
            />
            <span className="student__profile__name">
              {data.first_name} {data.last_name}
            </span>
          </div>

          <div className="student__profile__sort">
            <div className="sort__inner">
              <div className="sort__left">
                {/* <SubjectSelect
                  value={filter.subject_id}
                  onChange={(item) => {setFilter({...filter, subject_id: item?.value})}}
                />

                <GradeSelect
                  value={filter.grade_id}
                  onChange={(item) => {setFilter({...filter, grade_id: item?.value})}}
                /> */}
              </div>
              <div className="sort__right">
                {/* <div className="info__block">

                  <div className="info__item done">
                    <span className="info__circle"></span>
                    <span className="info__number">
                      9
                    </span>
                    <span className="info__text">
                      A
                    </span>
                  </div>

                  <div className="info__item need">
                    <span className="info__circle"></span>
                    <span className="info__number">
                      4
                    </span>
                    <span className="info__text">
                      B
                    </span>
                  </div>

                  <div className="info__item mistake">
                    <span className="info__circle"></span>
                    <span className="info__number">
                      2
                    </span>
                    <span className="info__text">
                      C
                    </span>
                  </div>

                  <div className="info__item">
                    <span className="info__circle"></span>
                    <span className="info__number">
                      1
                    </span>
                    <span className="info__text">
                      Need to do
                    </span>
                  </div>

                </div> */}

                <Select
                  black
                  placeholder="Period"
                  icon="/account/images/dest/icons/timetable--small.svg"
                  value={filter.period}
                  onChange={(item) => {
                    setFilter({ ...filter, period: item?.value })
                  }}
                  options={[
                    { value: 'all', label: 'All' },
                    { value: 'week', label: 'This week' },
                    { value: 'month', label: 'This month' },
                    { value: 'year', label: 'This year' },
                  ]}
                />
              </div>
            </div>
          </div>

          <div className="info__progress">
            <div className="info__progress__text">Number Sense</div>

            <div className="info__progress__item">
              <div
                className="info__progress__line done"
                style={{ width: '40%' }}
              />
              <div
                className="info__progress__line need"
                style={{ width: '25%' }}
              />
              <div
                className="info__progress__line mistake"
                style={{ width: '20%' }}
              />
              <div className="info__progress__line" style={{ width: '15%' }} />
            </div>
          </div>

          <div className="student__profile__table__inner">
            <div className="student__profile__table__wrapper">
              <div className="student__profile__table">
                <div className="student__profile__table__header">
                  <div className="row">
                    <div className="student__profile__table__header__col col-4" />
                    <div className="student__profile__table__header__col col-2">
                      Date/Time
                    </div>
                    <div className="student__profile__table__header__col col-1">
                      Time spent
                    </div>
                    <div className="student__profile__table__header__col col-2">
                      Last score
                    </div>

                    <div className="student__profile__table__header__col col-1">
                      Taken
                    </div>
                    <div className="student__profile__table__header__col col-2">
                      Score
                      <br />
                      improvement
                    </div>
                  </div>
                </div>

                <div className="student__profile__table__body">
                  {(data.tasksStat || []).map((item, i) => (
                    <div key={i} className="student__profile__table__line">
                      <div className="row">
                        <div className="student__profile__table__body__col col-4">
                          {item.title}
                        </div>
                        <div className="student__profile__table__body__col col-2">
                          {item.data}
                        </div>
                        <div className="student__profile__table__body__col col-1">
                          {item.time_spent}
                        </div>
                        <div className="student__profile__table__body__col col-2">
                          {item.score}
                        </div>
                        <div className="student__profile__table__body__col col-1">
                          {item.taken}
                        </div>
                        <div className="student__profile__table__body__col col-2">
                          <div
                            className={`student__profile__improve student__profile__improve--${
                              item.score_progress > 0 ? 'up' : 'down'
                            }`}
                          >
                            <span className="student__profile__improve__icon" />
                            {item.score_progress}%
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="student__profile__steps__wrapper">
            {/* <a href="#" className="step__item">
              <div className="step__wrapper">
                <img src="/account/images/dest/classroom/steps/3.svg" alt="StepItem" className="step__icon" />
                <div className="step__text">
                  Homework
                </div>
                <div className="step__subtext">
                  <span className="green__text--2">12</span>\16
                </div>
              </div>
              <div className="step__push">
              </div>
              <span className="step__push__text">34%</span>
            </a> */}

            <a href="#" className="step__item">
              <div className="step__wrapper">
                <img
                  src="/account/images/dest/classroom/steps/4.svg"
                  alt="StepItem"
                  className="step__icon"
                />
                <div className="step__text">Practices</div>
                <div className="step__subtext">
                  <span className="green__text--2">{data.practices_done}</span>\
                  {data.practices_total}
                </div>
              </div>
              <div className="step__push" />
              <span className="step__push__text">
                {data.practices_avg_score}%
              </span>
            </a>

            <a href="#" className="step__item">
              <div className="step__wrapper">
                <img
                  src="/account/images/dest/classroom/steps/5.svg"
                  alt="StepItem"
                  className="step__icon"
                />
                <div className="step__text">Tests</div>
                <div className="step__subtext">
                  <span className="green__text--2">{data.tests_done}</span>\
                  {data.tests_total}
                </div>
              </div>
              <div className="step__push step__push--yellow" />
              <span className="step__push__text">{data.tests_avg_score}%</span>
            </a>

            <a href="#" className="step__item step__item--white">
              <div className="step__wrapper">
                <img
                  src="/account/images/dest/classroom/steps/2.svg"
                  alt="StepItem"
                  className="step__icon"
                />
                <div className="step__text">Report cards</div>
                <div className="step__subtext">0</div>
              </div>
              <div className="step__push step__push--red" />
              <span className="step__push__text step__push__text--white">
                -6
              </span>
            </a>

            <a href="#" className="step__item step__item--white">
              <div className="step__wrapper">
                <img
                  src="/account/images/dest/classroom/steps/1.svg"
                  alt="StepItem"
                  className="step__icon"
                />
                <div className="step__text">Questions</div>
                <div className="step__subtext">0</div>
              </div>
            </a>
          </div>

          {/* <div className="cabinet__btn__wrapper classroom__btn__wrapper classroom__btn__wrapper--pupil">
            <button type="button" name="taskSubmit" className="btn btn--opacity cabinet__btn">Assign new</button>
          </div> */}
        </div>
      </div>
    </>
  )
}
